import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import dateFormat from '../../../../utils/dateFormat';
import ClaimsHistoryEntry from './ClaimsHistoryEntry';
import DocketEntry from '../../docket/docketEntries/DocketEntry';

const ClaimsEntry = ({ id, claim, onGetDocuments, selectedDocket, onGetClaimsDocuments, selectedClaim }) => {
  return (
    <Fragment>
      <tr>
        <td>{claim.claim_no}</td>
        <td>
          {claim.info.original_entered_date && <div>Original Entered Date: {claim.info.original_entered_date}</div>}
          {claim.info.original_filed_date && <div>Original Filed Date: {claim.info.original_filed_date}</div>}
          {claim.info.last_amendment_filed && <div>Last Amendment: {claim.info.last_amendment_filed}</div>}
        </td>
        <td style={{ whiteSpace: 'pre-wrap' }}>{claim.creditor}</td>
        <td style={{ textAlign: 'right' }}>
          $ {(claim.amounts && claim.amounts.amount && claim.amounts.amount.claimed) || '0.00'}
        </td>
        <td>{dateFormat(claim.modified)}</td>
      </tr>
      {claim.history.some(doc => !!doc.claim_no) && (
        <tr className="claim-detail claim">
          <td />
          <td colSpan="4">
            <h4>History / Documents</h4>
            <table>
              <tbody>
                {claim.history.map(
                  doc =>
                    doc.claim_no && (
                      <ClaimsHistoryEntry
                        id={`claim-history-${id}`}
                        key={`claim-history-${id}`}
                        claimHistory={doc}
                        court_code={claim.case_court}
                        case_number={claim.case_no}
                        onGetDocuments={onGetClaimsDocuments}
                        selectedClaim={selectedClaim}
                      />
                    )
                )}
              </tbody>
            </table>
          </td>
        </tr>
      )}
      {claim.history.some(doc => !!doc.docket_no) && (
        <tr className="docket">
          <td />
          <td colSpan="4">
            <h4>Related Dockets</h4>
            <table>
              <tbody>
                {claim.history.map(
                  doc =>
                    doc.docket_no && (
                      <DocketEntry
                        id={`docket-entry-${id}`}
                        key={`docket-entry-${id}`}
                        docket={doc}
                        redact={{}}
                        showRedactPopup={() => {}}
                        case_uuid=""
                        court_code={claim.case_court}
                        case_number={claim.case_no}
                        onGetDocuments={onGetDocuments}
                        selectedDocket={selectedDocket}
                      />
                    )
                )}
              </tbody>
            </table>
          </td>
        </tr>
      )}
      <tr className="claim-detail claim">
        <td />
        <td colSpan="4">
          <table className="borderless-table">
            <tbody>
              {claim.description && (
                <tr>
                  <td>Description:</td>
                  <td width="100%" dangerouslySetInnerHTML={{ __html: claim.description }} />
                </tr>
              )}
              {claim.remarks && (
                <tr>
                  <td>Remarks:</td>
                  <td width="100%" dangerouslySetInnerHTML={{ __html: claim.remarks }} />
                </tr>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </Fragment>
  );
};

ClaimsEntry.propTypes = {
  id: PropTypes.number.isRequired,
  claim: PropTypes.object.isRequired,
  selectedDocket: PropTypes.object.isRequired,
  onGetDocuments: PropTypes.func.isRequired,
  selectedClaim: PropTypes.object.isRequired,
  onGetClaimsDocuments: PropTypes.func.isRequired,
};

export default ClaimsEntry;



// WEBPACK FOOTER //
// ./src/components/case/claims/claimsEntries/ClaimsEntry.jsx